import API from './API'
import {
  MSG_ALERTES_API,
  MSG_INFOS_API,
} from '../constants/Constants'

function getMsgInfos() {
  return API({
    name: 'informations',
    method: 'get',
    url: MSG_INFOS_API,
  })
}

function getMsgAlertes() {
  return API({
    name: 'messages_alertes',
    method: 'get',
    url: MSG_ALERTES_API,
  })
}

export default {
  getMsgInfos,
  getMsgAlertes,
}
